import config from '../config';

export async function getProviderInfo(token) {
    const response = await fetch(`${config.API_URL}/provider`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    })
    if (response.status !== 200) {
        throw Error('Failed to fetch categories');
    }
    return (await response.json());
}


export async function updateProgress(data, token) {
    const response = await fetch(`${config.API_URL}/provider/progress`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(data)
    })
    if (response.status !== 200) {
        throw Error('Failed to fetch categories');
    }
    return (await response.json());
}


export async function uploadLicense(data, token) {
    const response = await fetch(`${config.API_URL}/provider/license`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(data),
    })
    if (response.status !== 200) {
        throw Error('Failed to upload license');
    }
    return (await response.json());
}

export async function removeLicense(branchId, token) {
    const response = await fetch(`${config.API_URL}/provider/license`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({branchId}),
    })
    if (response.status !== 200) {
        throw Error('Failed to upload license');
    }
    return (await response.json());
}
